import { Flex, IconButton, SystemProps } from '@chakra-ui/react'
import { faPaperPlane } from '@fortawesome/pro-regular-svg-icons'

import LikeButton from 'src/components/widgets/buttons/LikeButton/LikeButton'
import Icon from 'src/components/widgets/Icon/Icon'
import { ItListAnalyticsProps } from 'src/lib/hooks/analytics/useAnalytics'
import useShare from 'src/lib/hooks/useShare'

const ItListTopActions = ({
  itListId,
  liked,
  url,
  trackingData,
  ...props
}: {
  itListId: number
  liked: boolean
  url: string
  trackingData: ItListAnalyticsProps
} & SystemProps) => {
  const share = useShare()

  return (
    <Flex {...props} gap={4}>
      <LikeButton
        itListId={itListId}
        liked={liked}
        trackingData={trackingData}
      />
      <IconButton
        type="button"
        bg="white"
        display="flex"
        justifyContent="center"
        alignItems="center"
        p={1}
        aria-label="Upload icon button"
        icon={
          <Icon
            icon={faPaperPlane}
            boxSize="24px"
            display="flex"
            justifyContent="center"
            alignItems="center"
          />
        }
        onClick={async () => {
          await share(url, trackingData)
        }}
      />
    </Flex>
  )
}

export default ItListTopActions
